<span class="camera-info-label">Attach documents</span>
<div class="documents-container"
    *ngIf="!disabled"
    droppable
    (onDrop)="attachDocument($event)">
    <app-camera-attached-document-item
        *ngFor="let d of documents"
        [file]="d"
        (delete)="onRemoveFile($event)">
    </app-camera-attached-document-item>
</div>
